import requests from '../../../../request'

const baseUrl = '/stock/take/plan';
const selectorBaseUrl = '/selector';
const region = 'cloud-api';

const ContentTypeEnum = {
    // json
    JSON: 'application/json;charset=UTF-8',
    // form-data qs
    FORM_URLENCODED: 'application/x-www-form-urlencoded;charset=UTF-8',
    // form-data  upload
    BLOB: 'multipart/form-data;charset=UTF-8',
}

const ResponseEnum = {
  BLOB: 'blob',
}

/**
 * 选择器
 */
export function selector(params) {
  return requests({
    method: 'get',
    url: selectorBaseUrl + '/takestock/plan',
    params,
  }, {
    region,
  });
}

/**
 * 加载盘点任务
 */
export function loadTakeStockPlan(ids) {
  return requests({
    method: 'post',
    url: selectorBaseUrl + '/takestock/plan/load',
    data: ids,
  }, {
    contentType: ContentTypeEnum.JSON,
    region,
  });
}

/**
 * 查询列表
 */
export function query(params) {
  return requests({
    method: 'get',
    url: baseUrl + '/query',
    params,
  }, {
    region,
  });
}

/**
 * 导出
 */
export function exportList(data) {
  return requests({
    method: 'post',
    url: baseUrl + '/export',
    data,
  }, {
    region,
    responseType: ResponseEnum.BLOB,
    contentType: ContentTypeEnum.FORM_URLENCODED,
  });
}

/**
 * 查询详情
 */
export function get(id) {
  return requests({
    method: 'get',
    url: baseUrl,
    params: {
      id,
    },
  }, {
    region,
  });
}

/**
 * 查询详情
 */
export function getDetail(id) {
  return requests({
    method: 'get',
    url: baseUrl + '/detail',
    params: {
      id,
    },
  }, {
    region,
  });
}

/**
 * 根据预先盘点单、盘点任务查询商品信息
 */
export function getProducts(id) {
  return requests({
    method: 'get',
    url: baseUrl + '/products',
    params: {
      id,
    },
  }, {
    region,
  });
}

/**
 * 新增
 */
export function create(data) {
  return requests({
    method: 'post',
    url: baseUrl,
    data,
  }, {
    region,
    contentType: ContentTypeEnum.JSON,
  });
}

/**
 * 修改
 */
export function update(data) {
  return requests({
    method: 'put',
    url: baseUrl,
    data,
  }, {
    region,
    contentType: ContentTypeEnum.JSON,
  });
}

/**
 * 差异生成
 */
export function createDiff(id) {
  return requests({
    method: 'patch',
    url: baseUrl + '/diff',
    data: {
      id,
    },
  }, {
    region,
    contentType: ContentTypeEnum.FORM_URLENCODED,
  });
}

/**
 * 差异处理
 */
export function handleDiff(data) {
  return requests({
    method: 'patch',
    url: baseUrl + '/handle',
    data,
  }, {
    region,
    contentType: ContentTypeEnum.JSON,
  });
}

/**
 * 作废
 */
export function cancel(data) {
  return requests({
    method: 'patch',
    url: baseUrl + '/cancel',
    data,
  }, {
    region,
    contentType: ContentTypeEnum.FORM_URLENCODED,
  });
}

/**
 * 删除
 */
export function deleteById(id) {
  return requests({
    method: 'delete',
    url: baseUrl,
    data: {
      id,
    },
  }, {
    region,
    contentType: ContentTypeEnum.FORM_URLENCODED,
  });
}